<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div
        class="form-title padding-title"
        v-text="'Distribución'"
      />
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_combo_text"
              v-text="text"
            />

            <div
              class="form_label"
              v-text="'Código Cliente'"
            />
            <div class="form__field">
              <label for="codeClient"><v-icon
                name="id-card"
                scale="1"
              /></label>
              <input
                id="codeClient"
                ref="codeClient"
                v-model="codeClient"
                disabled
                autocomplete="off"
                type="text"
                name="codeClient"
                value=""
                placeholder=""
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'numbers')"
                @change="cleanSpecialChars('codeClient', 'numbers')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Dirección Local'"
            />
            <div class="form__field">
              <label for="localAdress"><v-icon
                name="map-marker-alt"
                scale="1"
              /></label>
              <input
                id="localAdress"
                ref="localAdress"
                v-model="localAdress"
                disabled
                autocomplete="off"
                type="text"
                name="localAdress"
                value=""
                placeholder=""
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'localAdress')"
                @change="cleanSpecialChars('codeClient', 'localAdress')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Teléfono *'"
            />
            <div class="form__field">
              <label
                for="phone"
              ><v-icon
                name="mobile-alt"
                scale="1"
              /></label>
              <input
                id="phone"
                ref="phone"
                v-model="phone"
                autocomplete="off"
                type="text"
                name="phone"
                value=""
                maxlength="9"
                placeholder="123456789"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('fantasyNameLocal')"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('phone', 'phone')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Nombre de fantasía local *'"
            />
            <div class="form__field">
              <label
                for="fantasyNameLocal"
              ><v-icon
                name="store"
                scale="1"
              /></label>
              <input
                id="fantasyNameLocal"
                ref="fantasyNameLocal"
                v-model="fantasyNameLocal"
                autocomplete="off"
                type="text"
                name="fantasyNameLocal"
                value=""
                placeholder="La licorería"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('firstName')"
                @keypress="keyPressCheckSpecialChars($event, 'fantasyNameLocal')"
                @change="cleanSpecialChars('fantasyNameLocal', 'fantasyNameLocal')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Nombre *'"
            />
            <div class="form__field">
              <label for="firstName"><v-icon
                name="user"
                scale="1"
              /></label>
              <input
                id="firstName"
                ref="firstName"
                v-model="firstName"
                autocomplete="off"
                type="text"
                name="firstName"
                value=""
                placeholder="Nombre de contacto"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('lastName')"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @change="cleanSpecialChars('firstName', 'name')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Apellido *'"
            />
            <div class="form__field">
              <label for="lastName"><v-icon
                name="user"
                scale="1"
              /></label>
              <input
                id="lastName"
                ref="lastName"
                v-model="lastName"
                autocomplete="off"
                type="text"
                name="lastName"
                value=""
                placeholder="Apellido de contacto"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @change="cleanSpecialChars('lastName', 'name')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Detalle de Atención'"
            />
            <select
              id="form_estilos"
              v-model="detailAttention"
              :multiple="false"
              :disabled="detailAttentionDisabled == 1"
              class="formulario_combo"
            >
              <option value>
                SELECCIONAR...
              </option>
              <option value="9">
                PEDIDO INCOMPLETO
              </option>
              <option value="13">
                PRODUCTO VENCIDO/DEFECTUOSO
              </option>
              <option value="14">
                PRODUCTO CAMBIADO
              </option>
              <option value="10">
                PROBLEMAS CON TRIPULACIÓN
              </option>
              <option value="15">
                COBRANZA ERRÓNEA
              </option>
              <option value="11">
                OTROS
              </option>
            </select>

            <div
              class="form_label"
              v-text="'Fecha Entrega Pedido *'"
            />
            <div class="form__field">
              <label for="deliveryDate"><v-icon
                name="calendar"
                scale="1"
              /></label>
              <input
                id="deliveryDate"
                ref="deliveryDate"
                v-model="deliveryDate"
                autocomplete="off"
                type="date"
                name="deliveryDate"
                value=""
                placeholder=""
                required
                @focus="_clearError"
                @keyup.enter="focusTo('missingProduct')"
              >
            </div>
            <template v-if="detailAttention === '9'">
              <div
                class="form_label"
                v-text="'Producto faltante *'"
              />
              <div class="form__field">
                <label
                  v-tooltip="'Ingresar información del producto igual al indicado en la factura, incluyendo la cantidad, señalando si son cajas o unidades'"
                  for="missingProduct"
                ><v-icon
                  name="box-open"
                  scale="1"
                /></label>
                <input
                  id="missingProduct"
                  ref="missingProduct"
                  v-model="missingProduct"
                  autocomplete="off"
                  type="text"
                  name="missingProduct"
                  value=""
                  placeholder="bebidas, cervezas, etc."
                  required
                  @focus="_clearError"
                  @keypress="keyPressCheckSpecialChars($event, 'missingProduct')"
                  @change="cleanSpecialChars('missingProduct', 'missingProduct')"
                >
              </div>
            </template>
            <!-- TEXTAREA -->

            <div
              class="score-subtitle"
              style="margin-bottom: 5px;"
            >
              Comentario
            </div>
            <div class="score-comments">
              <textarea v-model="comment" />
            </div>
          </div>
        </vuescroll>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/map-marker-alt'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/store'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/id-card'
import 'vue-awesome/icons/box-open'
import 'vue-awesome/icons/mobile-alt'
import utils from './utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {},
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      nombreOrigen: '',
      emailOrigen: '',
      telefonoOrigen: '',
      codeClient: '',
      localAdress: '',
      phone: '',
      fantasyNameLocal: '',
      firstName: '',
      lastName: '',
      detailAttention: '',
      deliveryDate: '',
      missingProduct: '',
      comment: '',
      detailAttentionDisabled: 0

    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'CCUDistribucionForm') return
      if (e.evento === 'init') {
        // console.log("asigna por init:");
        // console.log("e.dato:",e.dato);
      }
      if (e.evento === 'newdata') {
        // console.log("asigna por newdata:");
        // console.log("e.dato:",e.dato);
        // this.title = e.dato.title ? e.dato.title : "Contactar Ejecutivo";
        this.text = e.dato.text ? e.dato.text : ''
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoOrigen = e.dato.fields.phone ? e.dato.fields.phone : ''
        this.clientAddressOrigen = e.dato.fields.address ? e.dato.fields.address : ''
        this.clientCodeOrigen = e.dato.fields.client_code ? e.dato.fields.client_code : ''
        this.clientPhoneOrigen = e.dato.fields.client_phone ? e.dato.fields.client_phone : ''
        this.detailAttentionOrigen = e.dato.fields.detailAttentionSeleccion ? e.dato.fields.detailAttentionSeleccion : ''
        this.tokenOrigen = e.dato.fields.token ? e.dato.fields.token : ''
        this.firstName = this.nombreOrigen
        this.email = this.emailOrigen
        this.phone = this.telefonoOrigen
        this.codeClient = this.clientCodeOrigen
        this.localAdress = this.clientAddressOrigen
        this.phone = this.clientPhoneOrigen
        this.detailAttention = this.detailAttentionOrigen

        if (this.detailAttentionOrigen && this.detailAttentionOrigen !== '') {
          this.detailAttentionDisabled = 1
        }
      }
    })
  },
  methods: {
    _clearError () {
      this.errormsg = ''
    },
    focusTo (el) {
      this.$refs[el].focus()
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.codeClient) {
        this.$refs.codeClient.focus()
        this.errormsg = 'Debes ingresar Código Cliente'
        return
      }
      if (!this.localAdress) {
        this.$refs.localAdress.focus()
        this.errormsg = 'Debes ingresar Direccion Local'
        return
      }
      if (!this.phone) {
        this.$refs.phone.focus()
        this.errormsg = 'Debes ingresar teléfono'
        return
      }
      if (!this.fantasyNameLocal) {
        this.$refs.fantasyNameLocal.focus()
        this.errormsg = 'Debes ingresar Nombre de fantasía local'
        return
      }
      if (!this.firstName) {
        this.$refs.firstName.focus()
        this.errormsg = 'Debes ingresar Nombre'
        return
      }
      if (!this.lastName) {
        this.$refs.lastName.focus()
        this.errormsg = 'Debes ingresar Apellido'
        return
      }
      if (!this.detailAttention) {
        this.$refs.detailAttention.$refs.search.focus()
        this.errormsg = 'Debes seleccionar Detalle de Atención'
        return
      }
      if (!this.deliveryDate) {
        this.$refs.deliveryDate.focus()
        this.errormsg = 'Debes seleccionar Fecha Entrega Pedido'
        return
      }
      if (this.detailAttention === '9') {
        if (!this.missingProduct) {
          this.$refs.missingProduct.focus()
          this.errormsg = 'Debes seleccionar Producto faltante'
          return
        }
      }
      if (!this.comment) {
        this.errormsg = 'Debes ingresar Comentario'
        return
      }
      serverUI.$emit('FormEvent', {
        form: 'CCUDistribucionForm',
        evento: 'sentClick',
        data: {
          type: 'ccu-distribucion-form-confirm',
          fields: {
            codeClient: this.codeClient,
            localAdress: this.localAdress,
            phone: this.phone,
            fantasyNameLocal: this.fantasyNameLocal,
            firstName: this.firstName,
            lastName: this.lastName,
            detailAttention: this.detailAttention,
            deliveryDate: this.deliveryDate,
            missingProduct: this.missingProduct,
            comment: this.comment,
            token: this.tokenOrigen
          }
        }
      })
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'CCUDistribucionForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
  margin-bottom: 7px;
}

.form-box-body {
    height: 340px;
}
</style>
